import React from 'react';
import cn from 'classnames';

import {IVerifyFormProps} from './IVerifyForm';

import styles from './VerifyForm.module.scss';

const VerifyForm = ({classNames, children, onSubmit}: IVerifyFormProps) => {
	return (
		<form className={cn(styles['verify-form'], 'verify-form', classNames)} onSubmit={onSubmit}>
			{children}
		</form>
	);
};

export default VerifyForm;
